import { customerTypesLabels } from 'constants/companyConstants';
import industryType from 'constants/industryType';
import usStates from 'constants/usStates';

export const parseCompany = (company) => {
  const {
    id,
    name,
    address,
    address2,
    city,
    email,
    phone,
    number_of_employees: numberOfEmployees,
    zip,
    website,
    first_name: firstName,
    last_name: lastName,
    customer_type: type,
  } = company;
  let industry = industryType.find((el) => company.industry === el.id);
  let state = usStates.find((el) => company.state === el.id.toUpperCase());

  if (industry === undefined) {
    industry = { id: '', label: 'Unknown' };
  }

  if (state === undefined) {
    state = { id: '', label: '' };
  }

  const owner = firstName || lastName ? `${firstName} ${lastName}` : '';
  const typeLabel = customerTypesLabels[type];

  return {
    id,
    name,
    address: address || '',
    address2: address2 || '',
    city: city || '',
    email,
    industry,
    numberOfEmployees,
    phone,
    state,
    zip,
    owner,
    website: website || '',
    type,
    typeLabel,
  };
};

export const getCompanyInfo = (company) => [
  {
    name: 'Owner',
    value: company.owner,
  },
  {
    name: 'Contact number',
    value: company.phone || null,
    isPhoneNumber: true,
  },
  {
    name: 'Email',
    value: company.email,
  },
  {
    name: 'Website',
    value: company.website,
  },
  {
    name: 'Address',
    value: company.address,
  },
  {
    name: 'City',
    value: company.city,
  },
  {
    name: 'State',
    value: company.state?.label,
  },
  {
    name: 'ZIP code',
    value: company.zip,
  },
  {
    name: 'Industry type',
    value: company.industry?.label,
  },
  {
    name: 'Number of employees',
    value: company.numberOfEmployees,
  },
  {
    name: 'Company type',
    value: company.typeLabel,
  },
];

export const parseCompanyEmails = (email) => {
  return { id: email.id, name: email.subject, email: email.from_email };
};

export const parseCompanyTicket = (ticket) => {
  const ticketStatuses = {
    open: {
      label: ticket.status,
      color: 'warning',
    },
    solved: {
      label: ticket.status,
      color: 'success',
    },
    closed: {
      label: ticket.status,
      color: 'success',
    },
    default: {
      label: ticket.status,
      color: 'warning',
    },
  };

  return {
    id: ticket.id,
    url: `https://terraboost.zendesk.com/tickets/${ticket.id}`,
    createdAt: ticket.created_at,
    subject: ticket.raw_subject,
    status: ticketStatuses[ticket.status] || ticketStatuses.default,
  };
};
